module.exports = __webpack_public_path__ + "static/media/garage.bd890d63.svg";